import { FC, useState } from 'react';
import { Button } from '@mui/material';
import { AssignmentTurnedIn as AssignIcon } from '@mui/icons-material';
import { useNotify, useRefresh, useTranslate } from 'react-admin';
import { usePermission } from 'providers/auth/permissionProvider';
import BatchAssignToChannelModal from 'resources/units/components/BatchAssignToChannelModal';

interface AssignSerialsToChannelButtonProps {
  channelId: number;
}

export const AssignSerialsToChannelButton: FC<AssignSerialsToChannelButtonProps> = ({ channelId }) => {
  const [open, setOpen] = useState(false);
  const { hasPermission } = usePermission();
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!hasPermission('dev_options')) return null;

  const handleSuccess = (updatedCount: number) => {
    notify('resources.units.batch_assign_channel.success_all', {
      type: 'success',
      messageArgs: { count: updatedCount },
    });
    refresh();
    // Do not close the modal here — the modal shows a results screen that the
    // user dismisses manually via the Close button (onClose → setOpen(false)).
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AssignIcon />}
        onClick={() => setOpen(true)}
        sx={{
          'bgcolor': 'primary.main',
          'color': 'secondary.main',
          'borderRadius': '30px',
          'borderTopRightRadius': '10px',
          'textTransform': 'none',
          '&:hover': {
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'secondary.main',
            color: 'secondary.main',
          },
        }}
      >
        {translate('resources.units.batch_assign_channel.button')}
      </Button>

      <BatchAssignToChannelModal
        open={open}
        onClose={() => setOpen(false)}
        lockedChannelId={channelId}
        onSuccess={handleSuccess}
      />
    </>
  );
};
